import { AGE_SEGMENT_LABELS } from "@/constant/ageSegment";
import type {
  RawCategory,
  Segment,
  Category,
  NormalizedSegments,
} from "@interfaces/segments";
import { getAgeSegmentsNameBasedOnMarket } from "@/components/projectCommon/Filters/utils/utils";

export function normalizeSegments(
  data: RawCategory[],
  marketCodes?: string[]
): NormalizedSegments {
  const categories: Category[] = [];
  const segments: Segment[] = [];

  data.forEach((cat) => {
    const segmentIds: number[] = [];

    cat.segments.forEach((seg: any) => {
      segmentIds.push(seg.segmentId);

      segments.push({
        id: seg.segmentId,
        name:
          marketCodes &&
            marketCodes?.length > 0 &&
            AGE_SEGMENT_LABELS?.includes(seg.segmentName)
            ? getAgeSegmentsNameBasedOnMarket(marketCodes)
            : seg.segmentName,
        color: seg.color,
        order: seg.order,
        segmentMarkets: seg.segmentMarkets,
        filters: seg.filters,
        filterExpiresAt: seg.filterExpiresAt,
        module: seg.module,
        expiredFilters: seg.expiredFilters,
        detachedFilters: seg.detachedFilters,
        unFieldingFilters: seg.unFieldingFilters,
        isFiltersExpired: seg.isFiltersExpired,
        isFiltersFielding: seg.isFiltersFielding,
        isFiltersDetached: seg.isFiltersDetached,
        isApplicableForUser: seg.isApplicableForUser,
        isActive: seg.isActive,
        filterIdFilterMap: seg.filterIdFilterMap,
        categoryId: cat.categoryId,
      });
    });

    categories.push({
      id: cat.categoryId,
      name: cat.categoryName,
      categoryType: cat.categoryType,
      categoryOrder: cat.categoryOrder,
      segmentIds,
    });
    
  });

  const isAnySegmentActive = segments.some((segment) => segment.isActive);

  if (!isAnySegmentActive) {
    for (const segment of segments) {
      if (AGE_SEGMENT_LABELS.includes(segment.name)) {
        segment.isActive = true;
      }
    }
  }
  return { categories, segments };
}